import { Button, Text, useToast } from '@chakra-ui/react'
import { useExperienceManager } from '@hooks'
import { CloudDownload } from '@material-ui/icons'
import moment from 'moment'
import React, { useState } from 'react'
import { invoiceControllerDownloadSuperbill } from '~/clinician-api'

interface DownloadSuperbillButtonProps {
  invoiceId: string
  clientNamePrefix: string
  buttonsHaveText?: boolean
}

const DownloadSuperbillButton: React.FC<DownloadSuperbillButtonProps> = ({
  invoiceId,
  clientNamePrefix,
  buttonsHaveText = true
}) => {
  const { isProPlanEnabled } = useExperienceManager()
  const toast = useToast()
  const [isLoading, setIsLoading] = useState(false)

  const handleDownloadSuperbill = async () => {
    setIsLoading(true)
    const toastId = toast({
      title: 'Downloading superbill...',
      status: 'info',
      duration: 3000,
      isClosable: true
    })

    try {
      const blob = await invoiceControllerDownloadSuperbill(invoiceId)

      // Create download link
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `${clientNamePrefix}_superbill_${moment().format('MMDDYYYY')}.pdf`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)

      toast.update(toastId!, {
        title: 'Superbill downloaded successfully!',
        status: 'success',
        duration: 3000,
        isClosable: true
      })
    } catch (error) {
      console.error('Error downloading superbill:', error)
      toast.update(toastId!, {
        title: 'Error downloading superbill',
        description: 'An error occurred while downloading the superbill',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  // Only show for BP Pro users
  if (!isProPlanEnabled) {
    return null
  }

  return (
    <Button
      variant="outline"
      h="35px"
      borderRadius="4px"
      bg="white"
      borderColor="pale_gray"
      m="0"
      _focus={{ outline: 'none' }}
      onClick={handleDownloadSuperbill}
      disabled={!clientNamePrefix || !invoiceId || isLoading}
      isLoading={isLoading}
    >
      <CloudDownload />
      {buttonsHaveText && <Text ml="5px">Download superbill</Text>}
    </Button>
  )
}

export default DownloadSuperbillButton
